/**
 * WordPress dependencies
 */
import { useState, useEffect, useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Button } from "@wordpress/components";

import PatternContext from '../Context/PatternContext';

import PatternlySearchbox from "./PatternlySearchbox";


const PatternlySidebar = () => {

    const patternContext = useContext(PatternContext);

    const [error, setError] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const getDefaultData = (event) => {
        
        //active item.
        activeItem(event);

        // patternContext.setQueryType('all');
        // patternContext.setQueryTypeValue(false);

        let termName = event.currentTarget.getAttribute('termName');

        if(termName === 'color') {
            patternContext.setColorValue(false);
        }else if(termName === 'license') {
            patternContext.setLicenseValue(false);
        }else if(termName === 'mode') {
            patternContext.setModeValue(false);
        }else if(termName === 'section') {
            patternContext.setSectionValue(false);
        }else if(termName === 'category') {
            patternContext.setCategoryValue(false);
        }
        
        patternContext.setFavouriteValue(false);

        patternContext.setCurrentPage(1);
        patternContext.setLoadData(true);
        patternContext.setLoadMoreButton(true);
    }

    const getFavouriteItems = (event) => {
        patternContext.setLoadFavouriteData(true);
    };

    const activeItem = (event) => {

        let $this   = event.currentTarget;
        let list    = $this.parentElement;

        //remove active class.
        let activeCategoryItem = list.querySelector('.pat-sidebar-active');
        activeCategoryItem.classList.remove('pat-sidebar-active');

        //add active class.
        $this.classList.add('pat-sidebar-active');
    }

    const getTemplatesByTerm = (event) => {
        //active item.
        activeItem(event);

        let termName = event.currentTarget.getAttribute('termName');
        let termValue = event.currentTarget.getAttribute('termValue');

        // console.log(termName);
        // console.log(termValue);

        if(termName === 'color') {
            patternContext.setColorValue(termValue);
        }else if(termName === 'license') {
            patternContext.setLicenseValue(termValue);
        }else if(termName === 'mode') {
            patternContext.setModeValue(termValue);
        }else if(termName === 'section') {
            patternContext.setSectionValue(termValue);
            patternContext.setCategoryValue(false);
        }else if(termName === 'category') {
            patternContext.setCategoryValue(termValue);
            patternContext.setSectionValue(false);
        }

        patternContext.setQueryType(false);

        patternContext.setCurrentPage(1);
        patternContext.setLoadData(true);
        patternContext.setLoadMoreButton(true);
    }

    function renderTerms(termName) {
        if(Object.keys(patternContext.termData).length > 0 && patternContext.letsPrintTermData) {

            let termKey = '';

            if(termName === 'section') {
                termKey = 'sections';
            }else if(termName === 'category') {
                termKey = 'categories';
            }else if(termName === 'mode') {
                termKey = 'modes';
            }else if(termName === 'license') {
                termKey = 'licenses';
            }

            return(
                <ul className="pat-sidebar-ul">
                    <li 
                        class="pat-sidebar-li pat-sidebar-active"
                        termName={termName}
                        onClick={getDefaultData}
                    >
                            <span class="text">{__('All', 'patternly')}</span> 
                    </li>
                    {
                        patternContext.termData[termKey].map(termItem => {
                            return(
                                <li 
                                class="pat-sidebar-li" 
                                key={termItem.slug} 
                                termValue={termItem.slug}
                                termName={termName}
                                onClick={getTemplatesByTerm}
                                >
                                    <span class="text">{termItem.name}</span>
                                </li>
                            )
                        })
                    }
                </ul>
                
            )
        }
    }

    return (
        <>
            <div class="pat-sidebar">
                
                <div class="pat-sidebar-item">
                    <PatternlySearchbox />
                </div>
                
                <div class="pat-sidebar-item">
                    <a class="pat-fav-button" onClick={getFavouriteItems}>
                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5Z" fill="url(#paint0_linear_489_819)"/>
                            <defs>
                            <linearGradient id="paint0_linear_489_819" x1="10.0059" y1="-1.15276" x2="10.0059" y2="18.4082" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F1693C"/>
                            <stop offset="1" stop-color="#F13F05"/>
                            </linearGradient>
                            </defs>
                        </svg>
                        <span>{__('Favorites', 'patternly')}</span>
                    </a>
                    
                    <h4 class="pat-sidebar-menu-header">{__("Color Mode", "patternly")}</h4>
                    <ul class="pat-color-items">
                        <li 
                            className="pat-sidebar-li pat-sidebar-active"
                            key='light' 
                            termValue='light'
                            termName='mode'
                            onClick={getTemplatesByTerm}
                        >
                            <span class="pat-color-item" style={{background: '#fff'}}></span>
                        </li>
                        <li
                            className="pat-sidebar-li"
                            key='dark'
                            termValue='dark'
                            termName='mode'
                            onClick={getTemplatesByTerm}
                        >
                            <span class="pat-color-item" style={{background: '#000'}}></span>
                        </li>
                    </ul>
                </div>

                <div class="pat-sidebar-item">
                    <h4 class="pat-sidebar-menu-header">{__("Licenses", "patternly")}</h4>
                    {renderTerms('license')}
                </div>
                
                { patternContext.postType !== 'pattern' && (
                    <div class="pat-sidebar-item">
                        <h4 class="pat-sidebar-menu-header">{__("Categories", "patternly")}</h4>
                        {renderTerms('category')}
                    </div>
                ) }
                
                { patternContext.postType === 'pattern' && (
                    <div class="pat-sidebar-item">
                        <h4 class="pat-sidebar-menu-header">{__("Sections", "patternly")}</h4>
                        {renderTerms('section')}
                    </div>
                ) }
                
                <ul class="pat-skeleton-sidebar-ul">
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                </ul>
            </div>
        </>
    );
};

export default PatternlySidebar;